import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Upload,
  message as Message,
} from 'antd';
import Geocode from 'react-geocode';
import Resizer from 'react-image-file-resizer';
import i18n from 'i18next';
import { updateProfile } from '../../store/user/actions';
import { getUserState } from '../../store/user/selector';
import { getAppGlobalState } from '../../store/app-globals/selectors';
import PhotoCamera from '../../assets/images/png/camera.png';
import PhotoCameraActive from '../../assets/images/png/camera-active.png';

import PhoneInput, { formatPhoneNumberIntl } from 'react-phone-number-input';
import { setError, setLoading } from '../../store/app-globals/actions';
import { PageHeader } from '../layout/PageHeader';
import { fnCheckForRestrictedWords } from '../../constants/resctrictedWords';
import { colors } from '../../constants/colors';

const COOK = 'cook';

export interface ImageState {
  image: string;
}

export interface UserProps {
  state: any;
}

export const getBase64 = (img: Blob, callback: Function) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};

export const UploadPhotoContent: React.FC<ImageState> = ({ image }) => {
  return (
    <React.Fragment>
      <img
        src={image ? PhotoCameraActive : PhotoCamera}
        alt="camera"
        className="camera-icon"
      />
      {image && (
        <React.Fragment>
          <img
            src={image}
            alt="upload"
            className="create-profile-photo photo-upload-dragger"
          />
          <div className="cover-image-overlay"></div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export const UpdateProfile: React.FC = () => {
  const location = useLocation();
  const { state } = location;
  const userState: UserProps = {
    state,
  };
  const [image, setImage] = useState(userState.state.image);
  const [imageFile, setImageFile] = useState();
  const [value, setValue] = useState('');
  const { isLoading, message, hasError } = useSelector(getAppGlobalState);
  const { user } = useSelector(getUserState);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  // console.log(image);
  const [fields] = useState([
    {
      name: ['username'],
      value: userState.state.username,
    },
    {
      name: ['description'],
      value: userState.state.description,
    },
    {
      name: ['phone'],
      value: userState.state.phone,
    },
    {
      name: ['city'],
      value: userState.state.address.city,
    },
    {
      name: ['note'],
      value: userState.state.address.note,
    },
    {
      name: ['street'],
      value: userState.state.address.street,
    },
  ]);

  const normFile = (e: any): void => {
    // const maxsize = 400;
    // if (e.file.size / 1000 > maxsize) {
    //   setImage('');
    //   alert('image should be have 400kb max size');
    //   return;
    // }
    // getBase64(e.file.originFileObj, (imageUrl: string) => {
    //   setImage(imageUrl);
    // });
    Resizer.imageFileResizer(
      e.file.originFileObj,
      780,
      780,
      `${e.file.type}`,
      100,
      0,
      uri => {
        console.log(uri);
        setImage(uri);
      },
      'base64',
      400,
      400
    );
    return e && e.fileList;
  };

  const handleChange = (info: any): void => {
    // const maxsize = 400;
    // if (info.file.size / 1000 > maxsize) {
    //   setImageFile(undefined);
    //   return;
    // }
    setImageFile(info.file.name);
  };

  const onFinish = (values: any): void => {
    if (
      fnCheckForRestrictedWords(values.username) ||
      fnCheckForRestrictedWords(values.description) ||
      fnCheckForRestrictedWords(values.street) ||
      fnCheckForRestrictedWords(values.city) ||
      fnCheckForRestrictedWords(values.note)
    ) {
      Message.error(i18n.t('RESCTRICTED_MESSAGE'));
      return;
    }
    if (!image) {
      Message.error('Please select an image');
      return;
    }

    const address =
      userState.state.accountType === COOK
        ? {
            street: values.street,
            city: values.city,
            note: values.note ? values.note : '',
          }
        : {};
    if (user && user.accountType !== COOK) {
      // console.log('wew', image === user.image);
      Geocode.fromAddress(`${address.city} ${address.street}`).then(
        response => {
          const { lat, lng } = response.results[0].geometry.location;
          const phone = formatPhoneNumberIntl(values.phone);
          const details = {
            ...values,
            image,
            phone,
            filename: imageFile,
            address,
            location: { lat, lng },
          };
          // console.log('waawwaw', details);
          dispatch(updateProfile(details));
        },
        error => {
          // console.error('error', error);
        }
      );
      return;
    }

    const phone = formatPhoneNumberIntl(values.phone);
    const details = {
      ...values,
      image,
      phone,
      filename: imageFile,
      address: user.address,
      location: user.location,
    };
    // console.log('aw');
    dispatch(updateProfile(details));
  };
  useEffect(() => {
    if (hasError) {
      Message.error(i18n.t('Something went wrong'));
      dispatch(setError(false, ''));
      return;
    }
    if (!isLoading && message) {
      Message.success(i18n.t(`${message}`));
      setImageFile(undefined);
      // setDisabled(true);
      dispatch(setLoading(false, ''));
    }
  }, [isLoading, message, hasError, dispatch, form]);
  // console.log(image);
  return (
    <div>
      <PageHeader
        headerTitle={i18n.t(
          userState.state.accountType === COOK
            ? 'EDIT_PROFILE_HEADER_COOK'
            : 'EDIT_PROFILE_HEADER_GUEST'
        )}
      />
      <Row className="profile-container">
        <Col
          xs={24}
          sm={24}
          md={14}
          lg={10}
          xl={10}
          className="profile-wrapper"
        >
          <Form
            size="large"
            name="create-profile"
            className="create-profile-form"
            onFinish={onFinish}
            fields={fields}
            form={form}
          >
            <Form.Item
              name="upload"
              valuePropName="fileList"
              getValueFromEvent={normFile}
            >
              <Upload.Dragger
                name="files"
                className="create-profile-upload"
                multiple={false}
                onChange={handleChange}
              >
                <UploadPhotoContent image={image} />
              </Upload.Dragger>
            </Form.Item>
            {/* {imageFile ? null : (
              <span style={{ color: colors.orange }}>
                Note: {i18n.t('IMAGE_NOTE')}
              </span>
            )} */}
            <Form.Item
              name="username"
              rules={[{ required: true, message: i18n.t('INPUT_USERNAME') }]}
            >
              <Input placeholder="Username" />
            </Form.Item>

            <Form.Item
              name="description"
              rules={[{ required: true, message: i18n.t('INPUT_DESCRIPTION') }]}
            >
              <Input.TextArea rows={2} placeholder={i18n.t('Description')} />
            </Form.Item>

            <Form.Item
              name="phone"
              rules={[
                { required: true, message: i18n.t('INPUT_PHONE_NUMBER') },
              ]}
              className={
                userState.state.accountType === COOK
                  ? ''
                  : 'profile-margin-bottom'
              }
            >
              <PhoneInput
                international
                placeholder={i18n.t('PHONE_NUMBER')}
                value={value}
                onChange={setValue}
              />
            </Form.Item>

            {userState.state.accountType === COOK && (
              <div className="create-profile-address profile-margin-bottom">
                <Form.Item
                  name="street"
                  rules={[{ required: true, message: i18n.t('INPUT_STREET') }]}
                >
                  <Input placeholder={i18n.t('STREET')} />
                </Form.Item>
                <Form.Item
                  name="city"
                  rules={[{ required: true, message: i18n.t('INPUT_CITY') }]}
                >
                  <Input placeholder={i18n.t('CITY')} />
                </Form.Item>
                <Form.Item name="note">
                  <Input placeholder={i18n.t('ADDRESS_NOTES')} />
                </Form.Item>
              </div>
            )}

            <Form.Item className="form-bottom-item">
              <div className="primary-button-basic-container">
                <Button
                  shape="round"
                  className="primary-button-basic"
                  htmlType="submit"
                  loading={isLoading}
                >
                  {isLoading
                    ? message
                    : i18n.t(
                        userState.state.accountType === COOK
                          ? 'Became a Cook'
                          : 'Became a Guest'
                      )}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};
